import { render, staticRenderFns } from "./Department_show.vue?vue&type=template&id=764dbffc&"
import script from "./Department_show.vue?vue&type=script&lang=js&"
export * from "./Department_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports